export const invalid_token_text = 'error="invalid_token"';
export const token_header_name = 'WWW-Authenticate';

const authTypes = {
  db: 'db',
  eoauth: 'eoauth',
};

export default authTypes;
